import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, BellSlash } from "@phosphor-icons/react";
import { enablePush, disablePush, getPushSubscription, isPushSupported } from "@/lib/push";
import { toast } from "sonner";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [pushOn, setPushOn] = useState(false);
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data));
    (async () => {
      const s = await isPushSupported(); setSupported(s);
      if (s) { const sub = await getPushSubscription(); setPushOn(!!sub); }
    })();
  }, []);
  const markRead = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    setItems((prev) => prev.map((x) => x.id === id ? { ...x, read: true } : x));
  };
  const togglePush = async () => {
    try {
      if (pushOn) { await disablePush(); setPushOn(false); toast.success("Push disabled"); }
      else { await enablePush(); setPushOn(true); toast.success("Push enabled — you'll get alerts even when the app is closed"); }
    } catch (e) { toast.error(e.message || "Could not update push"); }
  };
  return (
    <div className="space-y-4 max-w-3xl">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <Bell size={28} className="text-blue-600" />
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Notifications</h1>
        </div>
        {supported && (
          <button data-testid="push-toggle-btn" onClick={togglePush}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-md font-semibold text-sm ${pushOn ? "bg-emerald-100 text-emerald-800" : "bg-slate-900 text-white hover:bg-slate-800"}`}>
            {pushOn ? <><Bell size={16} weight="fill"/> Push enabled</> : <><BellSlash size={16}/> Enable push</>}
          </button>
        )}
      </div>
      {items.length === 0 && <div className="text-slate-500 py-10 text-center">You're all caught up.</div>}
      <div className="space-y-2">
        {items.map((n) => (
          <button key={n.id} onClick={() => markRead(n.id)} data-testid={`notif-${n.id}`}
            className={`w-full text-left card-tactile p-4 ${n.read ? "opacity-70" : ""}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="font-semibold text-slate-900">{n.title}</div>
              {!n.read && <span className="w-2 h-2 rounded-full bg-blue-600 mt-2 shrink-0" />}
            </div>
            <div className="text-sm text-slate-600 mt-1">{n.message}</div>
            <div className="label-caps mt-2">{new Date(n.created_at).toLocaleString()}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
